import { Link } from "react-router-dom";

export const ErrorPage = () => {
  return (
    <div className=" text-center pt-52">
      <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">Error 404</h1>
      <p className="text-white text-2xl ">Page not found. Please return back to {<Link to='/' className="text-white underline"> homepage</Link>}</p>
    </div>
  );
};
